import {Component, output} from '@angular/core';
import {Button} from 'primeng/button';
import {AccentComponent} from '@app/components/accent/accent.component';

@Component({
  selector: 'app-home',
  imports: [
    Button,
    AccentComponent
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  public onStart = output<boolean>();

  protected startQuiz = () => {
    this.onStart.emit(true);
  }
}
